<template>
  <div>
    <v-select
      label="Name"
      :closeOnSelect="true"
      taggable
      :options="users"
      v-model="inputVal"
      :dir="$vs.rtl ? 'rtl' : 'ltr'"
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
import DataService from "@/data/dataService.js";

export default {
  data() {
    return {
      users: [],
      selectedUsers: [],
    };
  },
  mounted() {
    var instance = this;
    DataService.GetAccountUsers("", "", 0, 20000).then(function (response) {
      instance.$set(
        instance,
        "users",
        response.data.map((mp) => {
          return {
            Name: `${mp?.FirstName} ${mp?.LastName}`,
            Id: mp?.Id,
          };
        })
      );
      if (instance.inputVal && !instance.inputVal.Id) {
        instance.inputVal = instance.users.filter(
          (u) => u.Id == instance.inputVal
        )[0];
      }
    });
  },
  methods: {},
  components: { vSelect },
  props: ["value"],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    PreselectedUsers: {
      handler(value) {
        var valueToLookFor = value.Id ? value.Id : value;
        this.inputVal = this.users.filter((u) => u.Id == valueToLookFor)[0];
      },
    },
    users: {
      handler() {

      },
    },
  },
};
</script>
